import { FunctionComponent } from "react";
import { Select } from 'antd';
import i18n, { changeLanguage, SupportLanguage } from '@components/i18n/i18n';

const Language: FunctionComponent<{}> = () => 
    (
        <>
            <Select onChange={(val:string) => changeLanguage(val)} defaultValue={i18n.language} style={{minWidth: '100px'}}>
                <Select.Option value={SupportLanguage.en_US}>English</Select.Option>
                <Select.Option value={SupportLanguage.zh_TW}>繁體中文</Select.Option>
            </Select>
        </>
    );

export default Language;